module.exports = __webpack_public_path__ + "img/checkmark-square.12988bfc.svg";